export function getDrillDownTarget(currentView, timeSlot) {
    if (timeSlot == null || timeSlot === "")
        return null;
    switch (currentView) {
        case "year":
            return { targetView: "week", targetDate: timeSlot };
        case "week":
            return { targetView: "day", targetDate: timeSlot };
        default:
            return null;
    }
}
//# sourceMappingURL=forecastViewUtils.js.map